{
  "(optional)": "(neobligāti)",
  "(required)": "(obligāti)"
}